import React from 'react';
import _ from 'lodash';

export default class ResultsForm {
	constructor(app){
		this.app = app;
		this.reset();
	}

	reset(){
		Object.assign(this, {
			experiment: null,
			participants: 0,
			averageTime: 0,
			quitters: 0,
			questionResults: [
				{
					id:'Question 1: What is your favorite color?',
					correctness: 0.75,
					averageTime: 3000,
					responses:[
						{name: 'Red', value:20},
						{name: 'Orange', value:21},
						{name: 'Yellow', value:35},
						{name: 'Green', value:32},
					],
					averageTimes:[
						{name: '1-5 seconds', value:20},
						{name: '6-10 seconds', value:21},
						{name: '11-15 seconds', value:35},
						{name: '15-20 seconds', value:32},
					],
				},
				{
					id:'Question 2: What is your least favorite color?',
					correctness: 0.75,
					averageTime: 4211,
					responses:[
						{name: 'Red', value:20},
						{name: 'Orange', value:21},
						{name: 'Yellow', value:35},
						{name: 'Green', value:32},
					],
					averageTimes:[
						{name: '1-5 seconds', value:20},
						{name: '6-10 seconds', value:21},
						{name: '11-15 seconds', value:35},
						{name: '15-20 seconds', value:32},
					],
				}
				
			]
		});
	}

	async load({experimentId}){
		this.app.startLoadingForm(this);
		try{
			let experiment = await this.app.http.getExperiment({experimentId});
			experiment = {
				...this.app.EXPERIMENT_DEFAULTS,
				...experiment
			};

			let responses = await this.app.http.getExperimentResponses({experimentId});

			let questionResults = this.formatResponses(responses);

			Object.assign(this, {
				experiment,
				participants: experiment.participants,
				averageTime: 0,
				quitters: 0,
				audience: this.getFriendlyAudienceName(experiment.rules),
				questionResults
			});

			this.app.stopLoadingForm(this);
		}catch(e){
			console.log(e);
			this.app.goToMessagePage({
				title: 'Unable to load experiment results',
				body: (<div>There was an error loading the experiment. Please try again.</div>)
			});
			this.app.stopLoadingForm(this, e);
		}
	}

	formatResponses(responses = []){
		// Get all the ones that are an element, and group them together by the idPath.
		let elementsGroupedByIdPath = _.groupBy(responses.filter(response => _.has(response, 'elementId')), 'idPath');

		let result = _.map(elementsGroupedByIdPath, events => {

			let firstEvent = events[0] || {};

			let timeSinceScreenArray = _.compact(events.map(event => event.timeSinceScreen));
			let averageTime =  _.sum(timeSinceScreenArray) / timeSinceScreenArray.length;

			let isCorrectArray = (events.filter(event => event.isCorrect !== null ).map(event => event.isCorrect));
			let correctness =  _.sum(isCorrectArray) / isCorrectArray.length;
			correctness = _.round(correctness, 2) * 100 + '%';
			if(isCorrectArray.length === 0){
				correctness = 'N/A'
			}

			let responsesMap = _.countBy(events, 'value');
			let responsesArray = _.map(responsesMap, (o,k) => ({name:k, value:o}) );
			let topResponses = _.sortBy(responsesArray, 'count').reverse().slice(0,5);
			

			return {
				id: `${firstEvent.screenId}: ${firstEvent.elementId}`,
				idPath: firstEvent.idPath,
				correctness:correctness,
				averageTime: averageTime,
				responses: topResponses
			}
		
		});

		








		return result;
	}


	async downloadResponses({experimentId, format}){
		this.app.showFlashMessage({label: 'Downloading, please wait...'});
		try{
			await this.app.http.getExperimentResponses({experimentId, format, downloadFile:true});
			this.app.closeFlashMessage();
		}catch(e){
			this.app.showFlashMessage({label: 'Error downloading. ' + e, color:'red'});
		}
	}

	getFriendlyAudienceName(rules){
		let groupedRules = _.groupBy(rules, 'field');
		return _.map(groupedRules,  (ruleSet, k) => {
			return `(${ruleSet.map( rule => {
				let value = JSON.stringify(rule.value);
				let operator = rule.operator;
				if(rule.operator === 'any'){value = ''; operator = 'is set'}
				if(rule.operator === 'within'){value = `${rule.min} and ${rule.max}`}
				return `${rule.field} ${operator} ${value}`
			}).join(' OR ')})`;

		} ).join(' AND\n');
	}
	
}



// WEBPACK FOOTER //
// ./src/models/ResultsForm.js